import '@qse/ui/styles/globals.css'

import { setupAxios } from '@qse/api'
import { configureAmplify } from '@qse/config'
import { ENV } from '@qse/constants'
import { initSentry } from '@qse/sentry'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

// import '@heroui/react/dist/style.css';
import App from './App.tsx'
import { Provider } from './app-provider.tsx'

// Initialize Sentry before anything else
const isProductionHostname = window.location.hostname.includes('cloud.')
const isLocalhost = window.location.hostname.includes('localhost')
const environment = isProductionHostname ? 'production' : 'development'

initSentry({
  dsn: ENV.SENTRY_DSN || '',
  environment,
  release: `qse-web@${import.meta.env.npm_package_version || '0.0.1'}`,
  enabled: !isLocalhost && !!ENV.SENTRY_DSN,
  tracesSampleRate: environment === 'production' ? 0.1 : 1.0,
})

// Configure AWS Amplify first
configureAmplify({
  userPoolId: import.meta.env.VITE_AWS_USER_POOL_ID,
  userPoolClientId: import.meta.env.VITE_AWS_USER_POOL_CLIENT_ID,
})

// Then setup axios with the configured auth
setupAxios(import.meta.env.VITE_API_BASE_URL)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider>
        <App />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
)
